import React, { useEffect, useState } from "react";
import Typewriter from "typewriter-effect";
import { useInView } from "react-intersection-observer";
import { useAnimation } from "framer-motion";
import "./Banner.css";
import { image4, laptop, chairLaptop, image5 } from "./Images";
import ParticlesBg from "../particlesBg/PartclesBg";

const Banner = ({ homeRef }) => {
  const { ref, inView } = useInView();
  const animation = useAnimation();
  const [roleText, setRoleText] = useState();

  useEffect(() => {
    if (window.screen.width > 700) setRoleText("3rem");
    else setRoleText("2rem");
  }, [window.screen.width]);

  useEffect(() => {
    if (inView) {
      animation.start({
        scale: 1,

        transition: {
          ease: "easeInOut",
          duration: 1,
          delay: 0.2,
        },
      });
    } else {
      animation.start({
        scale: 0,
      });
    }
  }, [inView]);

  return (
    <>
      <div
        ref={homeRef}
        className="lg:px-60 h-screen flex flex-col items-center lg:flex-row justify-center lg:justify-between z-10 bg-[#121212]"
      >
        <img className="bgImage" src={chairLaptop} alt="" />
        <div className="fadout"> </div>
      
        <div className="z-10 text-white font-semibold">
          <p
            
            className="names text-2xl lg:text-3xl  text-white font-semibold pb-3"
           
          >
            Hello, I Am
          </p>
          <h1 className="names flex space-x-4 text-3xl lg:text-6xl text-white font-bold ">
            Ashok Zarmariya
          </h1>

          <div className="flex flex-col justify-center text-blue-600 text-xl lg:text-5xl font-semibold py-1 lg:py-3">
            <Typewriter
              options={{
                strings: ["Full Stack Web Devloper"],
                autoStart: true,
                loop: true,
              }}
            />
          </div>
        </div>
        <div className="z-10 lg:h-[70vh] flex items-center justify-center shadow-blue-300">
          <img
            className=" rounded-b-full"
            src="Ashok_Profile.28114c80397ac5140966-removebg-preview.png"
            alt=""
          />
        </div>
      </div>
      
    </>
  );
};

export default Banner;
